<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Carte SIM non reçue</div>
</div>
@if (shippingAddress) {
    <div class="col-12">
        Une nouvelle carte SIM va être envoyée à l’adresse suivante (livraison en France métropolitaine et Corse
        uniquement) :
        <br><br>
    </div>
}

@if (shippingAddress) {
    <div class="d-flex justify-content-center">
        <app-address-card [shippingAddress]="shippingAddress" [displayButton]="false"></app-address-card>
    </div>
}
Pour modifier ou compléter votre adresse, <a routerLink="/compte/adresses/modifier/adresse-livraison">cliquez ici.</a> Une fois que vous l’aurez mise à jour, vous pourrez relancer la procédure Carte SIM non reçue.
<br/><br/>
Si cette adresse est exacte, cliquez sur Valider pour confirmer l’envoi d’une nouvelle carte SIM.
<br/><br/>
Le 1er renvoi est gratuit. Si nous vous avons déjà renvoyé une carte SIM, l’expédition de cette nouvelle SIM sera facturée {{ priceDetails?.price }}.

<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        @if (shippingAddress) {
            <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
        }
    </div>
</div>
